<template>
  <div>
    <div
      class="main"
      :class="[{ focused: isFocusedView }, { 'golf-main': isGolfService }]"
    >
      <p class="title">계정정보</p>
      <p class="user-name">{{ userName }} 님</p>
      <div v-if="isExpired" class="expire-date">
        <div class="line2">사용중인 이용권이 없습니다</div>
        <div class="line3">{{ purchaseText }}</div>
      </div>
      <div v-else class="expire-date">
        <span class="line1">{{ userSubscription.name }}</span
        ><span class="date">{{ computedEndDate }} 만료</span>
      </div>
      <button
        :class="{ active: focusIndex === 0 }"
        @click="backKeyProc"
        @mouseover="focusIndex = 0"
      >
        나가기
      </button>
      <button
        :class="{ active: focusIndex === 1 }"
        @click="dispatchSubData"
        @mouseover="focusIndex = 1"
      >
        이용권 정보 새로고침
      </button>
    </div>
  </div>
</template>

<script>
import { userInScope, isGolf } from "@/utils/common";

export default {
  data() {
    return {
      isActiveVue: true,
      focusIndex: 0,
      timer: null,
      isGolfService: isGolf,
    };
  },
  computed: {
    userSubscription() {
      return this.$store.getters.userSubscription;
    },
    keyInput() {
      return this.$store.getters.keyInput;
    },
    fousedView() {
      return this.$store.getters.focusedView;
    },
    isFocusedView() {
      return this.fousedView === "default";
    },
    userName() {
      return this.$store.getters.userInfo.name;
    },
    computedEndDate() {
      if (this.userSubscription.endDate) {
        return this.userSubscription.endDate.substr(0, 10).replace(/-/gi, ".");
      } else {
        return "";
      }
    },
    isExpired() {
      if (this.userSubscription.endDate) {
        return new Date() > new Date(this.userSubscription.endDate);
      } else {
        return true;
      }
    },
    purchaseText() {
      const text = isGolf
        ? "SPOTV NOW Golf 앱 또는 www.spotvnowgolf.co.kr에서 구매 가능합니다"
        : "SPOTV NOW 앱 또는 www.spotvnow.co.kr에서 구매 가능합니다";

      return text;
    },
  },

  watch: {
    keyInput(val, oldVal) {
      if (this.isActiveVue && val.focusView == "default") {
        switch (val.key) {
          case "ArrowLeft":
            this.leftKeyProc(val);
            break;
          case "ArrowRight":
            this.rightKeyProc(val);
            break;
          case "Enter":
            this.enterKeyProc(val);
            break;
          case "Backspace":
            this.backKeyProc(val);
            break;
        }
      }
    },
  },
  methods: {
    leftKeyProc(keyInput) {
      if (this.focusIndex === 0) {
        this.$store.commit("SET_FOCUSED_VIEW", "gnb");
      } else {
        this.focusIndex = 0;
      }
    },
    rightKeyProc(keyInput) {
      this.focusIndex = 1;
    },
    enterKeyProc(keyInput) {
      if (this.focusIndex === 0) {
        this.$router.go(-1);
      } else {
        this.dispatchSubData();
      }
    },
    backKeyProc(keyInput) {
      this.clearTimer();
      this.$router.go(-1);
    },
    dispatchSubData() {
      this.clearTimer();
      this.timer = setTimeout(async () => {
        this.$progress.$emit("on:progress");
        await this.$store.dispatch("FETCH_SESSION").then((response) => {
          userInScope(response.data, () =>
            this.$progress.$emit("off:progress")
          );
        });
      }, 300);
    },
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
  },
  created() {
    this.$progress.$emit("on:progress");
    this.$store.dispatch("FETCH_USER_SUBSCRIPTION").then((res) => {
      this.$progress.$emit("off:progress");
    });
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.clearTimer();
    this.isActiveVue = false;
  },
};
</script>

<style lang="less" scoped>
.main {
  left: 176px;
  top: 198px;

  &.focused {
    .active {
      border: solid 4px #eeeeee;
    }
  }

  .title {
    font-size: 56px;
    color: #eeeeee;
  }
  .user-name {
    font-size: 40px;
    margin-top: 72px;
    color: #eeeeee;
  }
  .expire-date {
    margin-top: 24px;
    margin-bottom: 160px;

    .line1 {
      font-size: 28px;
      line-height: 1;
      color: #2affcc;
    }
    .date {
      font-size: 28px;
      line-height: 1;
      color: #888888;
      margin-left: 20px;
    }
    .line2 {
      font-size: 28px;
      line-height: 1;
      color: #ff0050;
    }
    .line3 {
      font-size: 28px;
      line-height: 1;
      color: #888888;
      margin-top: 24px;
    }
  }

  button {
    width: 276px;
    height: 80px;
    margin: 0 24px 0 0;
    background-color: #3e3e3e;
    font-size: 28px;
    text-align: center;
    color: #eeeeee;
    border: none;
  }

  &.golf-main {
    .expire-date {
      .line1 {
        color: #ff4600;
      }
    }
  }
}

@media all and (min-width: 0px) and (max-width: 1280px) {
  .main {
    &.focused {
      .active {
        border: solid 3px #ffffff;
      }
    }

    .title {
      font-size: 40px;
      font-weight: bold;
      color: #ffffff;
    }

    .user-name {
      font-size: 24px;
      margin-top: 48px;
      color: #ffffff;
    }

    .expire-date {
      margin-top: 20px;
      margin-bottom: 80px;
      font-size: 20px;

      .line1 {
        font-size: 20px;
        font-weight: bold;
        line-height: 1;
        color: #2affcc;
      }

      .line2 {
        font-size: 20px;
        font-weight: bold;
        line-height: 1;
        color: #ff0050;
      }

      .line3 {
        font-size: 16px;
        line-height: 1;
        color: #888888;
        margin-top: 12px;
      }

      .date {
        font-size: 16px;
        line-height: 1;
        color: #888888;
        margin-left: 8px;
      }
    }

    button {
      width: 181px;
      height: 56px;
      margin: 0 24px 0 0;
      background-color: #3e3e3e;
      font-size: 18px;
      text-align: center;
      color: #ffffff;
      border: none;
      font-weight: bold;
      vertical-align: top;
      font-family: NanumBarunGothic;
    }
  }
}
</style>
